import { Dropdown, DropdownProps } from "antd";
import { FC } from "react";

export type IncDropdownProps = DropdownProps;

export const IncDropdown: FC<IncDropdownProps> = (props) => (
    <Dropdown {...props} />
);
